
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class WhatsAppTemplateVariablesGrid extends Serenity.EntityGrid<WhatsAppTemplateVariablesRow, any> {
        protected getColumnsKey() { return WhatsAppTemplateVariablesColumns.columnsKey; }
        protected getDialogType() { return WhatsAppTemplateVariablesDialog; }
        protected getIdProperty() { return WhatsAppTemplateVariablesRow.idProperty; }
        protected getInsertPermission() { return WhatsAppTemplateVariablesRow.insertPermission; }
        protected getLocalTextPrefix() { return WhatsAppTemplateVariablesRow.localTextPrefix; }
        protected getService() { return WhatsAppTemplateVariablesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}